import paypal from '@/services/paypal.vue';

export default {
    install(Vue: any, options: any) {
        //var context = null;
        //Vue.mixin({
        //    created() {
        //        context = this;
        //    }
        //});
        //@ts-ignore
        paypal.options = options;
        Vue.component('paypal', paypal);
    }
}
